import Dexie from 'dexie';

const ZZZ_DB = new Dexie('ZZZ_DB');

ZZZ_DB.version(1).stores({
    dealers: `id, dealer, site`
});

export default ZZZ_DB;
